module.exports = __webpack_public_path__ + "img/weather21.5d5c485a.png";